module.exports = __webpack_public_path__ + "img/intranet_logo.0673708d.svg";